import React, { useEffect, useState } from 'react';
import { Heading, useDisclosure } from '@chakra-ui/react';
import { FaUserPlus } from 'react-icons/fa';

import ModalCreatePostVenta from './ModalCrearPostVenta';
import TablePostventas from './Tabla';
import SearchBar from '../../Common/SearchAutocomplete';
import NoResultsMessage from '../../Common/NoResultsMsg';
import { Loading } from '../../Common/Loading';

import { obtenerPostventas } from '../../../services/Admin/obtenerPostventas';
import './post.css';
import { useTranslation } from 'react-i18next';

export default function MostrarUsuariosPostventas() {
  const { t } = useTranslation();
  const {
    isOpen: isOpenModalCreatePostVenta,
    onOpen: onOpenModalCreatePostVenta,
    onClose: onCloseModalCreatePostVenta,
  } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);

  const [postVentas, setPostVentas] = useState([]);
  const [postVentasActivos, setPostventasActivos] = useState([]);
  const [filteredPostVentas, setFilteredPostVentas] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');
  const [searchList, setSearchList] = useState([]);
  const [error, setError] = useState({ error: false, msg: '' });

  useEffect(() => {
    loadPostventas();
  }, []);

  //llenar lista de barra de busqueda
  useEffect(() => {
    setFilteredPostVentas(postVentas);
    setSearchList(postVentas.map((item) => item.nombre));
  }, [postVentas]);

  const loadPostventas = () => {
    setIsLoading(true);
    obtenerPostventas().then((res) => {
      if (res.status === 200) {
        setPostVentas(res.data.postVentas);
        setIsLoading(false);

        const postVentasActivos = res.data.postVentas.filter(
          (postVenta) => postVenta.activo
        );
        setPostventasActivos(postVentasActivos);
      }
    });
  };

  const handleSearchTerm = (e) => {
    setSearchTerm(e.target.value);
    setError({ error: false, msg: '' });
  };

  const searchPostventa = (e) => {
    e.preventDefault();
    if (searchTerm.trim() === '') {
      setFilteredPostVentas(postVentas);
      setError({ error: true, msg: t('ENTER_NAME') });
      return;
    }

    const filtered = postVentas.filter((postVenta) =>
      postVenta.nombre.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredPostVentas(filtered);
  };

  const reloadSearch = () => {
    setError({ error: false, msg: '' });
    setFilteredPostVentas(postVentas);
    setSearchTerm('');
  };

  return (
    <div className="postV-container">
      <div className="postV-titlerow">
        <div>
          <Heading
            as="h3"
            size={{
              base: 'lg',
              md: 'xl',
              xl: 'xl',
            }}
          >
            {t('SEARCH_POSTSELL_AGENT')}
          </Heading>
          <form
            onSubmit={searchPostventa}
            className="d-flex justify-content-between my-3"
          >
            <SearchBar
              placeholder={t('ENTER_POSTSELL_AGENT_NAME')}
              list={searchList}
              onChange={handleSearchTerm}
              value={searchTerm}
              onSearch={searchPostventa}
              onReloadSearch={reloadSearch}
            />
          </form>

          {
            error.error ? (
              <span className="text-danger">{error.msg}</span>
            ) : (
              <span
                className="text"
                style={{ color: '#fff' }}
              >
                .
              </span>
            )
            //el punto sirve para no mover la UI
          }
        </div>
        <div>
          <button
            onClick={onOpenModalCreatePostVenta}
            className="btn btn-outline-orange circle-button"
          >
            <FaUserPlus  style={{width:"100%", height:"100%"}}/>
          </button>
          <ModalCreatePostVenta
            isOpen={isOpenModalCreatePostVenta}
            onClose={onCloseModalCreatePostVenta}
            loadPostventas={loadPostventas}
          />
        </div>
      </div>
      <div className="postV-tablerow">
        {isLoading ? (
          <Loading />
        ) : filteredPostVentas.length > 0 ? (
          <TablePostventas
            datos={filteredPostVentas}
            loadPostventas={loadPostventas}
            postVentasActivos={postVentasActivos}
          />
        ) : (
          <NoResultsMessage searchTerm={searchTerm} />
        )}
      </div>
    </div>
  );
}
